console.log('js compiled!')


GLightbox();
